import { FormHelperText } from '@mui/material';
import { Control, Path, Controller, FieldValues } from 'react-hook-form';
import FileInput from 'src/components/FileInput';

interface Props<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  label: string;
}

const FileInputController = <T extends FieldValues>({ name, label, control }: Props<T>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => {
        return (
          <>
            <FileInput {...field} label={label} />
            {fieldState.error && <FormHelperText error>{fieldState.error.message}</FormHelperText>}
          </>
        );
      }}
    />
  );
};

export default FileInputController;
